import styled from 'styled-components';

import Skeleton from '@/components/atom/Skeleton';

const MagazineItemSkeleton = () => {
  return (
    <Wrapper>
      <Left>
        <Row>
          <Skeleton style={{ width: 60, height: 18, marginRight: 8 }} />
          <Skeleton style={{ width: 66, height: 18 }} />
        </Row>
        <Skeleton style={{ height: 48, marginTop: 8, marginBottom: 4 }} />
        <Skeleton style={{ height: 18, marginBottom: 2 }} />
        <Skeleton style={{ width: '70%', height: 18 }} />
      </Left>
      <Right>
        <Skeleton style={{ width: 96, height: 72, marginBottom: 4 }} />
        <Skeleton style={{ width: 96, height: 28 }} />
      </Right>
    </Wrapper>
  );
};

const MagazineSkeleton = () => {
  return (
    <div>
      {Array.from({ length: 8 }).map((_, i) => (
        <MagazineItemSkeleton key={`skeleton_${i}`} />
      ))}
    </div>
  );
};

export default MagazineSkeleton;

const Wrapper = styled.div`
  padding: 24px;
  display: flex;
`;

const Left = styled.div`
  width: calc(100% - 96px);
  margin-right: 20px;
`;
const Row = styled.div`
  display: flex;
`;
const Right = styled.div``;
